export const UPDATE_FINDER_FIELD = 'UPDATE_FINDER_FIELD';
export const INITIATE_SEARCH = 'INITIATE_SEARCH';
export const CLEAR_FINDER_STATE = 'CLEAR_FINDER_STATE';
export const RECEIVE_CATEGORY_RESULTS = 'RECEIVE_CATEGORY_RESULTS';
export const RECEIVE_ARTICLE_PAGEVIEWS = 'RECEIVE_ARTICLE_PAGEVIEWS';
export const RECEIVE_ARTICLE_PAGEASSESSMENT = 'RECEIVE_ARTICLE_PAGEASSESSMENT';
export const RECEIVE_ARTICLE_REVISION = 'RECEIVE_ARTICLE_REVISION';
export const RECEIVE_ARTICLE_REVISIONSCORE = 'RECEIVE_ARTICLE_REVISIONSCORE';
export const SORT_ARTICLE_FINDER = 'SORT_ARTICLE_FINDER';
export const RECEIVE_KEYWORD_RESULTS = 'RECEIVE_KEYWORD_RESULTS';
export const CLEAR_RESULTS = 'CLEAR_RESULTS';

export const fetchStates = {
  ARTICLES_LOADING: 0,
  TITLE_RECEIVED: 1,
  PAGEASSESSMENT_RECEIVED: 2,
  REVISION_RECEIVED: 3,
  REVISIONSCORE_RECEIVED: 4,
  PAGEVIEWS_RECEIVED: 5
};
